import Splide from '@splidejs/splide';

const sliders = document.querySelectorAll('.slider-content__slider');

sliders.forEach(slider => {
    const descriptions = slider
        .closest('.slider-content')
        .querySelectorAll('.slider-content__description');
    let prevIndex = 0;

    const splide = new Splide(slider, {
        perPage: 3,
        perMove: 1,
        arrows: true,
        pagination: false,
        type: 'loop',
        focus: 'center',
        gap: '2rem',
        classes: {
            arrows: 'slider-content__arrows',
            arrow: 'slider-content__arrow',
            prev: 'slider-content__arrow--prev',
            next: 'slider-content__arrow--next',
        },
        breakpoints: {
            992: {
                perPage: 2,
                focus: 0,
            },
            768: {
                perPage: 1,
                gap: '1rem',
                focus: 0,
            },
        },
    });

    // Dodajemy obsługę kliknięć na slidy
    slider.addEventListener('click', e => {
        const slideElement = e.target.closest('.splide__slide');
        if (slideElement) {
            const slides = Array.from(splide.Components.Elements.slides);
            const clickedIndex = slides.indexOf(slideElement);
            splide.go(clickedIndex);
        }
    });

    // Ustaw pierwszy opis jako aktywny
    if (descriptions[0]) {
        descriptions[0].classList.add('-active');
    }

    splide.on('moved', function () {
        const activeSlide = splide.Components.Elements.slides[splide.index];
        const activeIndex = Array.from(
            splide.Components.Elements.slides
        ).indexOf(activeSlide);

        // Określ kierunek
        const isMovingRight =
            activeIndex > prevIndex ||
            (prevIndex === descriptions.length - 1 && activeIndex === 0);

        // Znajdź aktualnie aktywny opis
        const currentActive = slider
            .closest('.slider-content')
            .querySelector('.slider-content__description.-active');

        if (currentActive) {
            // Dodaj odpowiednią klasę w zależności od kierunku
            currentActive.classList.add(
                isMovingRight ? '-leaving-left' : '-leaving-right'
            );
            currentActive.classList.remove('-active');

            // Usuń klasę leaving po zakończeniu animacji
            setTimeout(() => {
                currentActive.classList.remove(
                    '-leaving-left',
                    '-leaving-right'
                );
            }, 400);
        }

        // Dodaj klasę aktywną do nowego opisu z odpowiednim kierunkiem
        if (descriptions[activeIndex]) {
            descriptions[activeIndex].classList.add('-active');
            descriptions[activeIndex].classList.add(
                isMovingRight ? '-from-right' : '-from-left'
            );

            setTimeout(() => {
                descriptions[activeIndex].classList.remove(
                    '-from-right',
                    '-from-left'
                );
            }, 50);
        }

        prevIndex = activeIndex;
    });

    splide.mount();
});
